import { AudioManager, ITrack, Track } from "../../AudioManager";
import { ISystemContext } from "../../Context/SystemContext";
import { LogGroup, Size, Scale, SetStyles, Log } from "../../MyHelpers";
import { MyVideo } from "../../MyVideo";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { VideoResource, VideoResource2 } from "../../ResourceManager/VideoResource";
import { Settings, JackpotDisplayType } from "../../Settings";
import { ZIndex } from "../../ZIndex";
import { SpinAndHoldParams } from "../Bonus/SpinAndHold/SpinAndHoldParams";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { ITransition } from "./ITransition";
import { TweenMax } from "gsap";
import { ITransitionParams } from "./ITransitionFactory";

export class VideoSpriteTransition implements ITransition {

    protected systemContext: ISystemContext = null;
    protected params: ITransitionParams = null;

    protected view: HTMLElement = null;
    protected audio: AudioManager = null;
    protected resid: ResourceIdentifier = null;
    protected logGroup: LogGroup = null;
    protected gameName: string = null;
    protected TitleSpriteTransition: CanvasSprite = null;
    protected spriteResource : SpriteResource ;
    protected videoResource : VideoResource2;
    protected track : ITrack ; 
    protected nameResource : string;
    protected fadeOut : boolean;

    public onTransitionStart: () => void = null;
    public onTransitionEnd: () => void = null;
    

    public constructor( params: ITransitionParams) {
        this.params = params;
        this.resid = params.resid;
        this.audio = params.audio;
        this.logGroup = params.logGroup
        this.gameName = params.gameName;
        this.systemContext = params.systemContext;
        this.spriteResource = params.spriteResource;
        this.track = params.soundResource;
        this.videoResource = params.videoResource;
        this.nameResource = params.nameResource;
        this.fadeOut = params.fadeOut;

        this.view = document.createElement("div");
        this.view.classList.add(this.resid.Scope());
        this.view.classList.add(this.gameName + "TransitionSpinHold");


    }
    //public CreateTransitionPixi: () => void = null;
    //public DestroyTransitionPixi: () => void = null;

    public CreateTransitionPixi () {};
    public DestroyTransitionPixi () {};



    public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {

        //this.PrepareTitleTransition(resourceManager);
        //this.PrepareVideoTransition(resourceManager);
    };
    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {

        this.LoadVideoTransition(resourceManager);
        this.LoadTitleTransition(resourceManager);
    };

    public PrepareVideoTransition(resourceManager: ResourceManager) {
        // resourceManager.AddGlobal(new VideoResource2({
        //     resid:  ResourceIdentifier.Global.Add(this.gameName),
        //     logGroup: LogGroup.Global.Add(this.gameName),
        //     src: `${Settings.ResourcesFolder}multigame/slot/${this.gameName}/resources/video/presentation_${Settings.Screens}s"`,
        //     unloadOnHide: true
        // }));
    }

   
    

    public LoadTitleTransition(resourceManager: IReadOnlyResourceManager) : void {

        this.TitleSpriteTransition = new CanvasSprite({sprite: this.spriteResource.sprite.Copy(), canvasSize: new Size(Scale.W(1920), Scale.H(1080))});
        this.TitleSpriteTransition.View().style.position = "absolute";
        if( Settings.Screens == 1 )
        {
            this.TitleSpriteTransition.View().style.position = "relative";
        }
        this.TitleSpriteTransition.View().style.display = "none";
        this.TitleSpriteTransition.View().style.top = Scale.Ypx(0);
        //this.TitleSpriteTransition.View().style.left="60px";
        this.TitleSpriteTransition.View().style.zIndex = ZIndex.BonusTransitionTitle.toString();
        //this.TitleSpriteTransition.View().style.display="none";
        this.TitleSpriteTransition.View().classList.add("TitleTransition-StickySpin");
        //this.TitleSpriteTransition.AddOnStartCallback(() => { this.audio.Play(this.resid.ScopedResourceName("transitionLight")); })
        this.TitleSpriteTransition.AddOnStartCallback(() => { this.track.Play(); })
        this.view.appendChild(this.TitleSpriteTransition.View());
    }


    public LoadVideoTransition(resourceManager: IReadOnlyResourceManager) {
        //let transitionVideo: MyVideo = this.videoResource.video;
        SetStyles(this.videoResource.video.View(), { position: "absolute", bottom: Scale.Ypx(0), left: Scale.Xpx(0), zIndex: ZIndex.BonusTransition.toString() });
        this.systemContext.SharedVideoContext().AddVideo(this.videoResource.video);
        this.videoResource.video.AddOnPlayCallback(this.resid, () => this.OnTransitionStarted());
        this.videoResource.video.AddOnEndedCallback(this.resid, () => this.OnTransitionEnded());
    }
    protected started: boolean = false;
    public ShowTransiton(): void {
        if (this.started == false) {
            this.started = true;
            // Log.Debug(this.logGroup, "Start transition");
            let video = this.systemContext.SharedVideoContext().GetVideo(ResourceIdentifier.Global.Add(this.nameResource));
            video.Play(this.resid);
            TweenMax.set(video.View(), { autoAlpha: 1 });
            // show video
            video.Show();
            // Fade Out and Fade In 

            this.fadeSettings(video);


           // this.onTransitionStart?.();
        }


    };

    protected fadeSettings(video : MyVideo) {
        
        if (this.fadeOut == true){

            //FADE OUT VIDEO 
            setTimeout(() =>
            TweenMax.to(video.View(), 2, {
                autoAlpha: 0, onComplete: () => {
                    video.StopAndReset(this.resid);
                    video.Hide();

                }
            }
            ), video.Duration() / 2.5);

            //FADE IN TRANSITION , 
            //FADE OUT DISABLE WILL BE STAY ALL TRANSITION
            setTimeout(() =>
            TweenMax.to(this.TitleSpriteTransition.View(), 1,
                { autoAlpha: 1 ,display : "block",onStart: () => { 
                    this.TitleSpriteTransition.Start(false);
                }, onComplete :() =>{
                    TweenMax.to(this.TitleSpriteTransition.View(), 2, {
                       autoAlpha: 0 ,display : "none" ,
                    })
                    
                }
                },
            ), 500);
                


        }
        else 
        {
            // ITS DISABLE FADE OUT IN VIDEOs
            //FADE IN AND FADE OUT TITLE ANIM ENABLED
            setTimeout(() =>
            TweenMax.to(this.TitleSpriteTransition.View(), 2,
                { autoAlpha: 1 , display : "block", onComplete :() =>{
                    this.TitleSpriteTransition.Start(false);
                    TweenMax.to(this.TitleSpriteTransition.View(), 1.5, {
                        autoAlpha: 0 , delay : 2.5 , display : "none"
                    })
                }
                },
            ), 500);
        }        
        
    }    
         
        
    
    public View(): HTMLElement {
        return this.view
     };



    public OnTransitionStarted() {
        // Log.Debug(this.logGroup, "Transition started");
        this.onTransitionStart?.();

    }

    public OnTransitionEnded(): void {
        // Log.Debug(this.logGroup, "Transition ended");
        this.started = false;

        this.onTransitionEnd?.();
    }

    public Update():void
    {
        this.TitleSpriteTransition.Update();
    }

    OnResize(): void {
        throw new Error("Method not implemented.");
    }
}
